
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ProductsProvider } from './context/products_context'
import { FilterProvider } from './context/filter_context'
import { CartProvider } from './context/cart_context'
import { UserProvider } from './context/user_context'
import { Auth0Provider } from '@auth0/auth0-react'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain='dev-61y50j51.us.auth0.com'
    clientId='gb4o2sLuB5svg52GKfzZUcB8E5B7XC8d'
    redirectUri={window.location.origin}
    cacheLocation='localstorage'
  >
<UserProvider>
  <React.StrictMode>
    <ProductsProvider>
      <FilterProvider>
        <CartProvider>
      <App />

        </CartProvider>

      </FilterProvider>
    </ProductsProvider>
  </React.StrictMode>
</UserProvider>
  </Auth0Provider>
);
// dev-61y50j51.us.auth0.com
//gb4o2sLuB5svg52GKfzZUcB8E5B7XC8d